module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data02-f72fe252087d2f83982b19f030822410.png";